// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fabClass.btn--bottom{bottom:70px}.fabclassD{bottom:70px!important;right:9px!important}", ""]);
// Exports
module.exports = exports;
